import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// ⭐ Star Rating Component
const StarRating = ({ rating }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
            <span key={i} className={`me-1 ${i <= rating ? "text-warning" : "text-muted"}`}>
                ★
            </span>
        );
    }

    return (
        <div className="d-flex align-items-center">
            {stars}
            <span className="ms-2 fw-semibold">{parseFloat(rating).toFixed(1)}</span>
        </div>
    );
};

const CourseList = ({ data, StyleVar }) => {
    return (
        <div className={`rn-card h-100 d-flex flex-column ${StyleVar}`}>
            <div className="inner d-flex flex-column h-100">
                {/* Course Image */}
                <div className="thumbnail position-relative">
                    <Link to={`/course-details/${data.slug}`}>
                        <img
                            src={`${data.image}`}
                            alt="Course"
                            className="img-fluid w-100"
                            style={{ height: "200px", objectFit: "cover" }}
                        />
                    </Link>
                </div>

                {/* Course Title */}
                <h4 className="text-center my-3 flex-grow-0">
                    <Link to={`/course-details/${data.slug}`}>
                        {data.title}
                    </Link>
                </h4>

                {/* Rating & Price Row */}
                <div className="d-flex justify-content-center align-items-center px-5 mb-3 flex-grow-0 text-center">
                    {/* <div className="flex-shrink-0">
                        <StarRating rating={parseFloat(data.rating) || 4.5} />
                    </div> */}
                    <div className="flex-shrink-0">
                        <span className="text-success fw-bold"><del className="text-white">৳{data.regularPrice} </del> ৳{data.price}</span>
                        {/* <span className="text-success fw-bold">৳{data.price}</span> */}
                    </div>
                </div>

                {/* Spacer */}
                <div className="flex-grow-1"></div>

                {/* Button */}
                <div className="text-center pb-4">
                    <Link
                        to={`/course-details/${data.slug}`}
                        className="btn-default w-100"
                    >
                        See Details
                    </Link>
                </div>
            </div>
        </div>
    );
};

CourseList.propTypes = {
    data: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        image: PropTypes.string,
        title: PropTypes.string,
        rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    StyleVar: PropTypes.string,
};

export default CourseList;
